// extracted by mini-css-extract-plugin
export default {"formList":"index_formList_O2YJr","formHorizontal":"index_formHorizontal_5Kv1k","picInfo":"index_picInfo_yfjDh"};